import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
/*import { MatRadioModule } from '@angular/material/radio';*/
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RouterModule } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { I18NextModule } from 'angular-i18next';
// import { TooltipModule } from 'ng2-tooltip-directive';
import { DashboardModule } from 'src/app/dashboards/dashboard.module';
import { ReportBasicInfoComponent } from 'src/app/reports/reports-details/nested-components/reports-basic-info/reports-basic-info.component';
import { ReportsDialogExportComponent } from 'src/app/reports/reports-details/nested-components/reports-dialog-export/reports-dialog-export.component';
import { ReportsDialogSaveAsEditComponent } from 'src/app/reports/reports-details/nested-components/reports-dialog-save-as-edit/reports-dialog-save-as-edit.component';
import { ReportSaveButtonsComponent } from 'src/app/reports/reports-details/nested-components/reports-save-buttons/reports-save-buttons.component';
import { WebEngageReportsVisualizationComponent } from 'src/app/reports/reports-details/nested-components/reports-visualization/web-engage-reports-viualization.component';
import { BaseWebEngageReportsSettingsComponent } from 'src/app/reports/reports-details/nested-components/reports-web-engage-settings/base/base-web-engage-reports-settings.component';
import { WebEngageReportsSettingsComponent } from 'src/app/reports/reports-details/nested-components/reports-web-engage-settings/report-settings/web-engage-reports-settings.component';
import { DialogDateFiltersComponent } from '../common/dialogs/dialog-date-filters/dialog-date-filters.component';
import { DialogDownloadTableComponent } from '../common/dialogs/dialog-download-table/dialog-download-table.component';
import { ColumnOrderComponent } from '../dashboards/components/column-order/column-order.component';
import { SharedModule } from '../shared/shared.module';
import { DataLoadingComponent } from './data-loading/data-loading.component';
import { reportsTimeDirective } from './directives/reportsTimeDirective';
import { BaseReportsDetailsComponent } from './reports-details/base/base-reports-details.component';
//import { ReportsDatePickerComponent } from 'src/app/reports/reports-date-picker/reports-date-picker.component';
import { PccReportsDetailsComponent } from './reports-details/pcc/pcc-reports-details.component';
import { RuleMatchDetailsComponent } from './reports-details/web-engage/rule-match-details.component';
import { ReportsDialogSubscriptionInfoComponent } from './reports-dialog-subscription-info/reports-dialog-subscription-info.component';
import { ReportsListPageComponent } from './reports-list-page/reports-list-page.component';
import { ReportsListComponent } from './reports-list/reports-list.component';
import { ReportsPageComponent } from './reports-page/reports-page.component';

@NgModule({
  declarations: [
    DialogDateFiltersComponent,
    ReportsListPageComponent,
    DataLoadingComponent,
    ReportSaveButtonsComponent,
    ReportsPageComponent,
    ReportsListComponent,
    PccReportsDetailsComponent,
    ReportBasicInfoComponent,
    //ReportsDatePickerComponent, // moved to DashboardModule
    DialogDownloadTableComponent,
    ReportsDialogExportComponent,
    ReportsDialogSaveAsEditComponent,
    reportsTimeDirective,
    ReportsDialogSubscriptionInfoComponent,
    ColumnOrderComponent,
    RuleMatchDetailsComponent,
    BaseReportsDetailsComponent,
    WebEngageReportsSettingsComponent,
    BaseWebEngageReportsSettingsComponent,
    WebEngageReportsVisualizationComponent
  ],
  imports: [
    DashboardModule,
    CommonModule,
    SharedModule,
    MatButtonModule,
    MatDialogModule,
    /*MatRadioModule,*/
    MatTooltipModule,
    MatSlideToggleModule,
    MatTabsModule,
    MatMenuModule,
    MatDatepickerModule,
    MatCheckboxModule,
    RouterModule,
    FormsModule,
    NgSelectModule,
    // TooltipModule,
    DragDropModule,
    I18NextModule.forRoot()
  ],
  exports: [    
  ]
})
export class ReportsModule { }
